<!--
 * @Description:
 * @Author: mdb
 * @Date: 2022-06-21 17:23:58
 * @LastEditTime: 2023-04-23 17:52:18
 * @LastEditors: mdb
-->
<template>
  <div class="tpl-form" :class="{ 'tpl-form-status__view': props.status === 'view' }">
    <div class="tpl-form-content">
      <a-form>
        <a-form-item :label="t('marketing.模板名称')" name="name" v-bind="validateInfos.name">
          <a-input
            class="width-60"
            v-model:value.trim="dataForm.name"
            :maxlength="50"
            allowClear
            :disabled="props.status === 'view'"
          />
        </a-form-item>
        <a-form-item :label="t('marketing.模板类型')" name="type" v-bind="validateInfos.type">
          <a-radio-group :disabled="props.status === 'view'" v-model:value="dataForm.type" @change="handleType">
            <a-radio :value="0">
              {{ t('marketing.APP模板1') }}
              <a-tooltip>
                <template #title>{{ t('marketing.模板提示1')}}</template>
                <ExclamationCircleOutlined :style="{ fontSize: '14px', fontWeight: 'normal' }" />
              </a-tooltip></a-radio>
            <a-radio :value="1">{{ t('marketing.APP模板2') }}
              <a-tooltip>
                <template #title>{{ t('marketing.模板提示2')}}</template>
                <ExclamationCircleOutlined :style="{ fontSize: '14px', fontWeight: 'normal' }" />
              </a-tooltip></a-radio>
            <a-radio :value="2">{{ t('marketing.Web模板') }}
              <a-tooltip>
                <template #title>{{ t('marketing.模板提示3')}}</template>
                <ExclamationCircleOutlined :style="{ fontSize: '14px', fontWeight: 'normal' }" />
              </a-tooltip></a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :label="t('marketing.说明')" name="remark">
          <a-textarea
            class="width-60"
            v-model:value="dataForm.remark"
            :maxlength="2000"
            :disabled="props.status === 'view'"
          />
        </a-form-item>
        <a-form-item :label="dataForm.type === 2 ? t('marketing.背景图建议2') : t('marketing.背景图建议1')" name="fileList" v-bind="validateInfos.fileList" v-if="props.status !== 'view'">
          <a-upload
            v-model:file-list="dataForm.fileList"
            action="/base/resource/file/upload"
            list-type="picture-card"
            :max-count="dataForm.type === 0 ? 1 : 5"
            name="files"
            :before-upload="beforeUpload"
            :customRequest="backgroundImagesRequest"
            :onRemove="onRemove"
            @preview="handlePreview"
          >
            <div v-if="dataForm.fileList && dataForm.fileList.length < (dataForm.type === 0 ? 1 : 5)">
              <plus-outlined />
              <div style="margin-top: 8px">{{ t('marketing.上传') }}</div>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item :label="t('marketing.提交成功展示图')" name="fileList" v-if="props.status !== 'view'">
          <a-upload
            v-model:file-list="dataForm.globalConfig.successImages"
            action="/base/resource/file/upload"
            list-type="picture-card"
            :maxCount="1"
            name="files"
            :before-upload="beforeUpload"
            :customRequest="successImagesRequest"
            @preview="handlePreview"
          >
            <div v-if="dataForm.globalConfig.successImages.length < 1">
              <plus-outlined />
              <div style="margin-top: 8px">{{ t('marketing.上传') }}</div>
            </div>
          </a-upload>
        </a-form-item>
      </a-form>
      <dl class="tpl-table" v-if="props.status !== 'view'">
        <dt class="tpl-table-thead">
          <div class="tpl-table-cell width-70">{{ t('marketing.排序') }}</div>
          <div class="tpl-table-cell required">{{ t('marketing.字段名称') }}</div>
          <div class="tpl-table-cell">{{ t('marketing.展示选项') }}</div>
          <div class="tpl-table-cell">{{ t('marketing.显示字段名') }}</div>
          <div class="tpl-table-cell width-100">{{ t('marketing.必填') }}</div>
          <div class="tpl-table-cell tpl-detele-icon"></div>
        </dt>
        <draggable v-model="draggableList" item-key="renderKey" filter=".not-allowed" class="tpl-table-row_wrap">
          <template #item="{ element, index }">
            <dd class="tpl-table-row" :class="{ active: isActiveIndex === index }" @click="handleClick(index)">
              <div class="tpl-table-cell width-70">
                <span>{{ index + 1 }}</span>
                <span class="iconfont icon-tuozhuaipaixu" />
              </div>
              <div class="tpl-table-cell" @click.stop>
                <a-select
                  v-model:value="element.field"
                  :fieldNames="{ value: 'field' }"
                  :placeholder="t('marketing.选择字段名称')"
                  :options="fieldsEnum"
                />
              </div>
              <div class="tpl-table-cell" @click.stop>
                <a-select
                  v-if="showCustomSelect(element.field)"
                  v-model:value="element.checked"
                  :fieldNames="{ label: 'name', value: 'id' }"
                  mode="multiple"
                  max-tag-count="responsive"
                  :placeholder="t('marketing.展示所有选项')"
                  :options="customSelectOption(element.field)"
                />
                <template v-else>{{ '--' }}</template>
              </div>
              <div class="tpl-table-cell">
                <a-input
                  v-if="editStatus && editableData[element.renderKey]"
                  v-model:value="editableData[element.renderKey]['label']"
                  :maxlength="100"
                  @change="inputChange(element, editableData[element.renderKey]['label'])"
                  @blur="onBlur(element.renderKey)"
                  v-focus
                />
                <template v-else>
                  {{ element.label || '--' }}
                  <img class="tpl-edit-icon" src="@/assets/marketing/edit1.svg" @click="edit(element.renderKey)" />
                </template>
              </div>
              <div class="tpl-table-cell width-100" @click.stop><a-switch v-model:checked="element.required" /></div>
              <div class="tpl-table-cell tpl-detele-icon" @click.stop="handleDelete(index)">
                <img src="@/assets/marketing/minus-circle-black.svg" v-if="dataForm.config.length > 1" />
              </div>
            </dd>
          </template>
        </draggable>
      </dl>
      <div class="tpl-add-button" @click="handleNewField()" v-if="props.status !== 'view'">
        <img src="@/assets/marketing/add-circle.svg" />
        <p>{{ t('marketing.新增字段') }}</p>
      </div>
    </div>
    <div class="tpl-form-preview">
      <div style="position: absolute; z-index: 0; width: 321px; height: 695px;">
        <a-carousel dot-position="top">
          
          <div v-for="item in dataForm.backgroundList" :key="item" class="picture" @click="handleExpand('img')">
            <!-- <div :style="{ background: `url(${dataForm.backgroundList ? dataForm.backgroundList[0]  : ''}) 100%/100% no-repeat`, backgroundSize: 'cover', -->

             <!-- }"> -->
              <img :src="item"  />
            <!-- </div> -->
          </div>
        </a-carousel>
      </div>
      <div v-if="isExpand || dataForm.type !== 0"  class="form-content"  @click="handleExpand('form')">
        <h3 style="text-align: center; border-bottom: 1px solid #CCCCCC66; margin-bottom: 16px; padding-bottom: 10px;" >{{ t('marketing.填写资料') }}</h3>
        <a-form
        layout="vertical"
          :model="previewForm"
          :colon="false"
          :label-col="{ style: { width: '300px', 'white-space': 'normal', 'line-height': 1.2 } }"
        >
          <a-form-item
            :label="item.label"
            :rules="[{ required: item.required }]"
            v-for="(item, index) in previewForm"
            :key="index"
          >
            <component
              :is="item.type === 'ParamCodeCascader' ? ParamCodeCascader : item.type"
              appId="cos_zbu"
              :props="item"
              :fieldNames="{ label: 'name', value: 'id' }"
              :placeholder="`${['AInput', 'ATextarea'].includes(item.type as string) ? t('common.pleaseInput') : t('common.pleaseSelect')}${item.label}`"
              v-bind="item.attrs"
            />
          </a-form-item>
          <!-- :options="previewCustomSelectOption(paramCodeData[item.paramCode], item.checked)" -->
        </a-form>
      </div>
      <div v-if="isExpand || dataForm.type !== 0"  class="btn-footer" :style="{ marginBottom: dataForm.type === 0 ? '3px': '19px', borderEndEndRadius: dataForm.type === 0 ? '0px' : '16px', borderEndStartRadius: dataForm.type === 0 ? '0px' : '16px' }">
        <a-button type="primary" block size="large" shape="round" @click="previewSubmit()">{{ t('btn.提交') }}</a-button>
      </div>

      <div v-if="!isExpand && dataForm.type === 0"  class="btn-footer" style="padding: 0;background: transparent; margin-top: auto; margin-bottom: 16px;">
        <a-button type="primary" block size="large" shape="round" @click="handleSave()">{{ t('marketing.填写资料') }}</a-button>
      </div>

      <!-- <a-modal v-model:visible="visible" title="隐私协议" width="100%" wrap-class-name="full-modal">
        <p>等产品找法务提供相关隐私协议</p>
      </a-modal> -->

      <a-modal :visible="previewVisible" :title="previewTitle" :footer="null" @cancel="handlePreviewCancel">
        <div style="max-height: calc(100vh - 300px); overflow-y: auto">
          <img alt="example" style="width: 100%" :src="previewImage" />
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, toRaw, computed, watchEffect, onBeforeMount, nextTick, PropType } from 'vue'
import { PlusOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { Form } from 'ant-design-vue'
import { message } from '@dc-platform/dc-components'
import draggable from 'vuedraggable'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import { cloneDeep } from 'lodash-es'
import templateFields, { ofbuTemplateFields } from '@/utils/templateFields'
import { customerTypeEnum, genderEnum, linkRoleTypeEnum } from '@/views/marketing/commonEnum/dataConfig'
import { uploadFileApi } from '@/api/common'
import { templateDetail } from '@/api/marketing/marketingManage'
import { useCustomSelect } from './useCustomSelect'
import { useEnum } from './useEnum'
import { paramCodesEnum } from '../common'
import type { UnwrapRef } from 'vue'
import type { UploadFile } from 'ant-design-vue'
import type { TemplateFieldType, TemplateEditParams } from '@/typings/api/marketingManage'
import { url } from 'inspector'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()

const props = defineProps({
  status: {
    type: String,
    required: true,
    validator(value: string) {
      return ['view', 'edit', 'add'].includes(value)
    }
  },
  templateId: Number,
  subdomain: {
    type: String as PropType<'fbu' | 'lbu' | 'ofbu'>,
    required: true
  }
})

const { showCustomSelect, customSelectOption } = useCustomSelect(props.subdomain)
const { adminAreaEnum, getAdminAreaList, paramCodeData, getByParamCodes, tagListEnum, getTagList } = useEnum()

const initGlobalConfig = {
  successImages: [] // 存数组，防止以后又要存多张图片
}

interface FieldType {
  field: string
  label: string
  checked?: number[] | string[]
  required: boolean
  renderKey?: number
}
interface Option {
  label: string
  field: string
  disabled?: boolean
  type?: string
  attrs?: any
}
interface RootObject {
  label: string
  options: Option[]
}

onBeforeMount(async () => {
  await getAdminAreaList()
  await getByParamCodes(props.subdomain)
  await getTagList()
  nextTick(() => {
    checkedFatmat()
  })
})

const draggableList = computed({
  get() {
    return dataForm.config as TemplateFieldType[]
  },
  set(val) {
    dataForm.config = val
  }
})

const fieldsFlatAll = (props.subdomain === 'ofbu' ? ofbuTemplateFields : templateFields).reduce((arr: any, item) => {
  let options = item.options
  // 此处云途筛选掉客户类别
  if (props.subdomain === 'lbu') {
    options = options.filter((item) => item.paramCode !== 'customerCategory')
  }
  arr = [...arr, ...options]
  return arr
}, [])
const fieldsEnum = ref<RootObject[]>(
  (props.subdomain === 'ofbu' ? ofbuTemplateFields : templateFields).map((item) => {
    // 此处云途筛选掉客户类别
    if (props.subdomain === 'lbu') {
      item.options = item.options.filter((option) => option.paramCode !== 'customerCategory')
    }

    item.options = item.options.map((i) => {
      i.label = i.lang ? t(i.lang) : i.label
      return i
    })
    item.label = item.lang ? t(item.lang) : item.label
    return item
  })
)
const dataForm = reactive<TemplateEditParams>({
  name: '',
  remark: '',
  background: '',
  fileList: [],
  type: 0,
  config: [
    {
      renderKey: Math.ceil(Math.random() * 100000000),
      field: '',
      label: '',
      required: false
    }
  ],
  globalConfig: cloneDeep(initGlobalConfig)
})
const formRules = reactive({
  name: [{ required: true, message: t('marketing.请输入模板名称') }],
  type: [{ required: true, message: t('marketing.请选择模板类型') }],
  fileList: [{ required: true, message: t('marketing.请上传背景图') }]
})
const useForm = Form.useForm
const { resetFields, validate, validateInfos } = useForm(dataForm, formRules)
const handleNewField = () => {
  const list = dataForm.config as TemplateFieldType[]
  list.push({
    renderKey: Math.ceil(Math.random() * 100000000),
    field: '',
    label: '',
    required: false
  })
}

// 根据 templateId 获取对应的模板数据，并将其转换为表单组件可用的数据格式
watchEffect(async () => {
  const templateId = props.templateId
  if (!templateId) {
    resetFields()
    dataForm.background = ''
    dataForm.id = undefined
    dataForm.templateId = undefined
    return
  }
  try {
    const { data } = await templateDetail({ templateId })
    const config = JSON.parse(data.config as string) as TemplateFieldType[] // 从 data 中解析出 config 字段并转换为指定类型

    const backgroundList = data.background.split(',') || []
    const fileList = backgroundList.map((item: string) => {
      return { url: item }
    }) // 根据是否存在 background 字段来设置 fileList，文件列表
    const globalConfig = data.globalConfig == null ? cloneDeep(initGlobalConfig) : JSON.parse(data.globalConfig) // 根据是否存在 globalConfig 字段来设置 globalConfig，全局配置

    isExpand.value = data.type === 0
    // 定义一个 formatData 对象，用来存储整合后的模板详情
    const formatData = {
      ...data,
      templateId: data.id,
      config: config.map((item) => ({
        label: item.label,
        field: item.field,
        checked: item.checked || undefined,
        required: item.required,
        renderKey: item.renderKey
      })),
      fileList,
      backgroundList,
      globalConfig
    }
    // 把整合后的模板详情赋值给 dataForm 对象
    Object.assign(dataForm, formatData)
  } catch (error) {
    console.error('Error getting template', error)
  }
})

/**
 * 监听可选字段
 */
watchEffect(() => {
  const checked = (dataForm.config as TemplateFieldType[]).map((e) => e.field)
  fieldsEnum.value.forEach((item) => {
    item.options.forEach((element) => {
      element.disabled = checked.includes(element.field)
    })
  })
})

const isActiveIndex = ref<number>()
const handleClick = (index: number) => {
  isActiveIndex.value = index
}
const editStatus = ref<boolean>(false)
const editableData: UnwrapRef<Record<string, FieldType>> = reactive({})
const edit = (key: number) => {
  editStatus.value = true
  editableData[key] = cloneDeep((dataForm.config as TemplateFieldType[]).filter((item) => key === item.renderKey)[0])
}
const handleDelete = (index: number) => {
  const list = dataForm.config as TemplateFieldType[]
  if (list.length > 1) {
    list.splice(index, 1)
  }
}

const handleType = () => {
  isExpand.value = dataForm.type === 1
}

const inputChange = (row: FieldType, value: string) => {
  row.label = value
}
const vFocus = {
  mounted: (el: HTMLElement) => el.focus()
}
const onBlur = (renderKey: number) => {
  editStatus.value = false
  delete editableData[renderKey]
}
const fieldslistAll = () => {
  return fieldsEnum.value.flatMap((ele) => ele.options)
}
const previewForm = computed(() => {
  const list = dataForm.config as TemplateFieldType[]
  const fieldsAll = fieldslistAll()
  return list.map((item) => {
    const fieldItem = fieldsAll.find((e) => e.field === item.field)
    if (fieldItem?.field === 'customerOffice') {
      fieldItem.attrs = {
        changeOnSelect: true,
        options: adminAreaEnum.value,
        fieldNames: { label: 'name', value: 'id' }
      }
    }
    if (fieldItem?.field === 'customerType') {
      fieldItem.attrs = {
        options: previewCustomSelectOption(customerTypeEnum, item.checked),
        fieldNames: { label: 'label', value: 'value' }
      }
    }
    if (fieldItem?.field === 'customerTag') {
      fieldItem.attrs.options = previewCustomSelectOption(tagListEnum.value, item.checked)
    }
    if (fieldItem?.field === 'contact.jobRole') {
      fieldItem.attrs = {
        options: previewCustomSelectOption(linkRoleTypeEnum, item.checked),
        fieldNames: { label: 'label', value: 'value' }
      }
    }
    if (fieldItem?.field === 'contact.sex') {
      fieldItem.attrs = {
        options: previewCustomSelectOption(genderEnum, item.checked),
        fieldNames: { label: 'label', value: 'value' }
      }
    }
    if (fieldItem?.field === 'business.cargoType') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].product],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.salePlatform') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].channel],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.warehouse') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].demand],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.monthSales') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].monthly],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.serviceNeeds') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].service],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.salesCategory') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].category],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.customerCategory') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].customerCategory],
        item.checked
      )
    }


    if (fieldItem?.field === 'business.shipments') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].shipments],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.businessTypeSelect') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].businessTypeSelect],
        item.checked
      )
    }
    if (fieldItem?.field === 'business.salesChannel') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].salesChannel],
        item.checked
      )
    }
    if (fieldItem?.field === 'clientType') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].clientType],
        item.checked
      )
    }
    if (fieldItem?.field === 'channel') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].clueChannel],
        item.checked
      )
    }

    if (fieldItem?.field === 'business.regionalWarehouse') {
      fieldItem.attrs.options = previewCustomSelectOption(
        paramCodeData.value[paramCodesEnum[props.subdomain].regionalWarehouse],
        item.checked
      )
    }
    // if (fieldItem?.field === 'business.cooperation') {
    //   fieldItem.attrs.options = previewCustomSelectOption(paramCodeData.value.zbu_existing_cooperation, item.checked)
    // }
    return Object.assign({}, fieldItem, {
      label: item.label || fieldItem?.label || '',
      checked: toRaw(item.checked) || undefined,
      required: item.required
    })
  })
})

const customRequest = (options: any) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData()
    formData.append('files', options.file)
    uploadFileApi(formData)
      .then((res: any) => {
        if (res.code === 200) {
          resolve(res.data)
        } else {
          message.error(res.message)
          reject(res.message)
        }
      })
      .catch((err) => {
        reject(err)
      })
  })
}
const beforeUpload = (file: UploadFile) => {
  const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
  if (!isJpgOrPng) message.error(t('marketing.上传限制1'))
  const isLt10M = file.size && file.size / 1024 / 1024 < 10
  if (!isLt10M) message.error(t('marketing.上传限制2'))
  return isJpgOrPng && !!isLt10M
}
/**
 * 上传背景图
 */
const backgroundImagesRequest = (options: any) => {
  customRequest(options)
    .then((res: any) => {
      options.onSuccess(res, options.file)

      dataForm.fileList?.splice(-1)
      dataForm.fileList = [...(dataForm.fileList || []), { url: res[0] }]

      dataForm.backgroundList = dataForm.fileList?.map((item) => item.url).filter((item: string) => item) ?? []
      dataForm.background = dataForm.backgroundList.join(',')
    })
    .catch(() => {
      // dataForm.background = ''
      // dataForm.fileList = []
    })
}
const onRemove = (options: any) => {
  const index = dataForm.fileList?.indexOf(options, 0) ?? -1
  if (index > -1) {
    dataForm.fileList?.splice(index, 1)
    dataForm.backgroundList = dataForm.fileList?.map((item) => item.url).filter((item: string) => item) ?? []
    dataForm.background = dataForm.backgroundList.join(',')
  }
}

/**
 * 上传提交成功展示图
 */
const successImagesRequest = (options: any) => {
  customRequest(options)
    .then((res: any) => {
      dataForm.globalConfig.successImages = [{ url: res[0] }]
    })
    .catch(() => {
      dataForm.globalConfig.successImages = []
    })
}

const isExpand = ref<boolean>(true)
const handleExpand = (type: 'img' | 'form') => {
  if (dataForm.type === 1) return

  if (type === 'img' && isExpand.value) isExpand.value = false
  if (type === 'form' && !isExpand.value) isExpand.value = true
}

const handleSave = () => {
  if (dataForm.type === 0) { isExpand.value = true }
}
// const visible = ref<boolean>(false)
// const showModal = () => {
//   visible.value = true
// }
const previewSubmit = () => {
  message.warning(t('marketing.预览提示'))
}

const emit = defineEmits(['cancel', 'submit'])
// const handleCancel = () => emit('cancel')
// const handleSubmit = () => emit('submit')
const handleSubmit = () => {
  validate()
    .then(() => {
      const result: any[] = []
      const list = dataForm.config as TemplateFieldType[]
      const hasEmpty = list.some((item) => item.field === '')
      if (hasEmpty) return message.warning(t('marketing.完善表单提示'))
      // 判断是否有客户名称和联系方式
      const fieldArr = list.map((item) => item.field)
      if (
        fieldArr.includes('customerName') && (
          (props.subdomain === 'ofbu' && (fieldArr.includes('contact.mobile') || fieldArr.includes('contact.skype')))
          || (fieldArr.includes('contact.mobile') ||
          fieldArr.includes('contact.email') ||
          fieldArr.includes('contact.wechat') ||
          fieldArr.includes('contact.qq') ||
          fieldArr.includes('contact.tel'))
        )
      ) {
        list.forEach((ele) => {
          const item = fieldsFlatAll.find((e: any) => e.field === ele.field)
          result.push(Object.assign({}, item, ele))
        })
        emit('submit', toRaw(dataForm))
      } else {
        return message.warning(t('marketing.模板保存提示'))
      }
    })
    .catch((err) => {
      console.log('error', err)
    })
}

// 预览图片
function getBase64(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
const previewVisible = ref(false)
const previewImage = ref('')
const previewTitle = ref('')
const handlePreviewCancel = () => {
  previewVisible.value = false
  previewTitle.value = ''
}
const handlePreview = async (file: any) => {
  if (!file.url && !file.preview) {
    file.preview = (await getBase64(file.originFileObj)) as string
  }
  previewImage.value = file.url || file.preview
  previewVisible.value = true
  previewTitle.value = file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
}

// 过滤下拉框选项
const previewCustomSelectOption = (oldList: any[], newList?: number[] | string[]) => {
  if (oldList == null) return []
  if (newList == null || newList.length === 0) return oldList || []
  const list = newList.map((item) => {
    const find = oldList.find((e: any) => e.id === item || e.value === item)
    return toRaw(find)
  })
  return list.filter((e) => e != null) || []
}

// 已选择数据和禁用的选项处理（临时）
const checkedFatmat = () => {
  const typeObj = {
    'business.cargoType': 'zbu_product_type',
    'business.salePlatform': 'zbu_channel_detail',
    'business.warehouse': 'zbu_demand_info',
    'business.monthSales': 'zbu_monthly_sales',
    'business.serviceNeeds': 'zbu_service_demand'
    // 'business.cooperation': 'zbu_existing_cooperation'
  }
  for (const key in typeObj) {
    if (Object.prototype.hasOwnProperty.call(typeObj, key)) {
      const element = typeObj[key]
      const config = dataForm.config as TemplateFieldType[]
      config.forEach((item: any) => {
        if (item.field === key && item.checked && item.checked.length) {
          for (let i = item.checked.length - 1; i >= 0; i--) {
            const find = paramCodeData.value[element].find((e) => e.id === item.checked[i])
            if (!find) item.checked.splice(i, 1)
          }
        }
      })
    }
  }
}

defineExpose({ handleSubmit })
</script>
<script lang="ts">
export default { name: 'MainForm' }
</script>

<style lang="scss" scoped>
.tpl-form {
  display: flex;
  height: 100%;
  padding: 0 14px;
  overflow-y: auto;
  transition: all 0.3s;
  .width-60 {
    width: 60%;
  }
  .tpl-form-content {
    flex: 1;
    margin-right: 30px;
    margin-bottom: 10px;
  }
  .tpl-form-preview {
    width: 321px;
    height: 595px;
    // border: 3px solid #132043;
    // border-radius: 18px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .picture {
      flex: 1;
      overflow-y: auto;
      img {
        // width: 100%;
        // height: 100%;
        width: 321px;
        height: 595px;
        border: 3px solid #132043;
        border-radius: 18px;
      }
    }
    :deep(.slick-dots) {
      top: 25% !important;
    }

    :deep(.slick-active button) {
      background: #3370FD !important;
    }
    .form-content {
      border-radius: 16px 16px 0 0;
      height: 50%;
      z-index: 999;
      max-height: 66%;
      padding: 16px 16px 0;
      background-color: #ffffff;
      margin: 0 16px;
      margin-top: auto;
      // overflow: hidden;
      overflow-x: hidden;
      overflow-y: auto;
      transition: all 0.3s linear;
      will-change: height;
      // &.is-expand {
      //   height: 50%;
      // }

      :deep(.ant-form-item) {
        display: flex;
        margin-bottom: 16px;
        line-height: 2;
        .ant-form-item-label {
          width: 100px;
        }
      }
    }
    .btn-footer {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 14%;
      padding: 0 16px;
      margin: 0 16px;
      z-index: 998;
      overflow: hidden;
      background-color: #ffffff;
      :deep(.ant-btn) {
        height: 40px;
        &.ant-btn-lg {
          font-size: 14px;
        }
      }
      :deep(.ant-checkbox-wrapper) {
        margin-top: 2%;
        color: #999999;
        &.ant-checkbox-wrapper-checked {
          color: #132043;
          .ant-checkbox-inner {
            background-color: #132043;
            border-color: #132043;
          }
        }
        .ant-checkbox {
          top: 0.18em;
        }
      }
    }
  }
  &.tpl-form-status__view {
    justify-content: center;
    .tpl-form-content {
      flex: none;
      width: 320px;
      :deep(.ant-form-item-control-input-content) {
        .ant-input,
        .ant-input-affix-wrapper {
          width: 100%;
        }
      }
    }
  }
}

.tpl-table {
  @mixin tplTableCell {
    display: flex;
    height: 40px;
    line-height: 40px;
    .tpl-table-cell {
      &:first-child {
        cursor: move;
      }
      &.width-70 {
        width: 70px;
        flex: none;
      }
      &.width-80 {
        width: 80px;
        flex: none;
      }
      &.tpl-detele-icon {
        visibility: hidden;
        width: 32px;
        flex: none;
        padding-left: 0;
        cursor: pointer;
      }
    }
  }

  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  padding-top: 10px;

  .tpl-table-cell {
    flex: 1;
    padding: 0 16px;
    &.required::before {
      display: inline-block;
      margin-right: 4px;
      color: #df443b;
      font-size: 14px;
      font-family: SimSun, sans-serif;
      line-height: 1;
      content: '*';
    }
    :deep(.ant-select) {
      width: 100%;
    }
    .icon-tuozhuaipaixu {
      display: none;
      margin-left: 2px;
      color: $Primary;
    }
  }
  .tpl-table-thead {
    @include tplTableCell;
    background: #f3f3f9;
  }
  .tpl-table-row {
    @include tplTableCell;
    margin-bottom: 0;
    border-bottom: 1px solid rgba(216, 223, 228, 0.4);
    &:last-child {
      border-bottom: none;
    }
    .width-70 {
      display: flex;
    }
    .tpl-edit-icon {
      display: none;
      padding: 6px;
      cursor: pointer;
    }
    &.active {
      background: #e4f0ff;
      .tpl-edit-icon {
        display: inline-block;
      }
      .tpl-detele-icon {
        visibility: inherit;
      }
      .icon-tuozhuaipaixu {
        display: inline-block;
      }
    }
  }
  :deep(.ant-switch-checked) {
    .ant-switch-handle {
      left: 55%;
    }
  }
}

.tpl-add-button {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  line-height: 1;
  border: 1px dashed #d8dfe4;
  cursor: pointer;
  transition: all 0.3s;
  &:hover {
    color: $Primary;
    border-color: $Primary;
  }
  p {
    margin-left: 11px;
  }
}

/* 如果宽度小于1260px */
@media (max-width: 1260px) {
  .tpl-table {
    max-width: 380px;
    overflow-x: auto;
  }
  .tpl-table-thead {
    width: 800px;
  }
  .tpl-table-row_wrap {
    width: 800px;
  }
}
/* 设定在宽度为320px～480px，分辨率是150dpi的设备上行高为 1.4 */
@media only screen and (min-width: 1261px) and (max-width: 1440px) {
  .tpl-table {
    max-width: calc(100vw - 880px);
    overflow-x: auto;
  }
  .tpl-table-thead {
    width: 800px;
  }
  .tpl-table-row_wrap {
    width: 800px;
  }
}
</style>
